import { reportError } from 'ha/helpers/bugsnag/reportError';
import { Thunk } from 'ha/myredux/types';
import { IntlObject } from 'ha/i18n';
import { getUserId } from 'ha/modules/AuthLogic/selectors';

import { Actions } from '../constants';
import { fetchListing } from '../helpers/fetchListing';

function loadListingStart() {
  return {
    type: Actions.LOAD_LISTING_START,
    error: false,
  };
}

function loadListingDone(payload: any) {
  return {
    type: Actions.LOAD_LISTING_DONE,
    payload,
    error: false,
  };
}

function loadListingFail(payload: { message: string }) {
  return {
    type: Actions.LOAD_LISTING_FAIL,
    payload,
  };
}

const loadListing =
  (
    id: number,
    parameters: {
      startDate?: string;
      endDate?: string;
      useUnitType?: boolean;
    },
    intl: IntlObject,
  ): Thunk =>
  (dispatch, getState, services) => {
    dispatch(loadListingStart());
    const currentUserId = getUserId(getState()) ?? -1;

    return fetchListing(
      id,
      { ...parameters },
      {
        ...services,
        intl,
      },
      currentUserId,
    )
      .then(({ listingEntity }) => {
        dispatch(
          loadListingDone({
            listing: listingEntity,
          }),
        );
      })
      .catch(error => {
        // @ts-ignore
        dispatch(loadListingFail({ message: error.message }));
        reportError('loadListing failed', { metaData: { id, error } });
      });
  };

export { loadListing };
